module.exports = __webpack_public_path__ + "media/nadvorie.97bb3fb9.mp4";